'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _iconClose = require('../icons/icon-close');

var _iconClose2 = _interopRequireDefault(_iconClose);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _overlay = require('../overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _portal = require('../portal');

var _portal2 = _interopRequireDefault(_portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'Dialog';

var propTypes = {
  /** Header text */
  header: _propTypes2.default.node,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the overlay element */
  overlayStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback fired when the close button is clicked
   *
   * function(event: object) => void
   */
  hideDialog: _propTypes2.default.func.isRequired,
  /** Optional children, will only render children and headerText with other styles */
  children: _propTypes2.default.node,
  /** The close button's icon color */
  iconColor: _propTypes2.default.string,
  /** Toggle the Dialogs visibility */
  open: _propTypes2.default.bool,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  overlayStyle: {},
  headerStyle: {},
  children: null,
  iconColor: _colors2.default.white,
  header: null,
  open: false
};

/** General purpose dialog */

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyUp = function (event) {
      var hideDialog = _this.props.hideDialog;


      if (event.which === 27) {
        hideDialog(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          header = _props.header,
          hideDialog = _props.hideDialog,
          style = _props.style,
          overlayStyle = _props.overlayStyle,
          headerStyle = _props.headerStyle,
          children = _props.children,
          iconColor = _props.iconColor,
          open = _props.open,
          color = _props.color,
          custom = _objectWithoutProperties(_props, ['header', 'hideDialog', 'style', 'overlayStyle', 'headerStyle', 'children', 'iconColor', 'open', 'color']);

      if (!open) {
        return null;
      }

      return _react2.default.createElement(
        _portal2.default,
        null,
        _react2.default.createElement(
          _overlay2.default,
          { style: overlayStyle },
          _react2.default.createElement('section', { style: _styles2.default.clickAway, onClick: hideDialog }),
          _react2.default.createElement(
            'section',
            _extends({ style: _getStyles2.default.root(color, style) }, custom),
            _react2.default.createElement(
              _button2.default,
              { style: _styles2.default.closeButton, onClick: hideDialog, iconButton: true },
              _react2.default.createElement(_iconClose2.default, { color: iconColor })
            ),
            header ? _react2.default.createElement(
              'h1',
              { style: _getStyles2.default.header(headerStyle) },
              header
            ) : null,
            children
          ),
          _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp })
        )
      );
    }
  }]);

  return Dialog;
}(_react.Component);

Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;
Dialog.displayName = displayName;

exports.default = Dialog;
module.exports = exports.default;